import clsx from "clsx";

import styles from "./FormLabel.module.scss";

type FormLabelProp = {
  label: React.ReactNode;
  className?: string;
};

const FormLabel = ({ label, className }: FormLabelProp) => {
  return (
    <div className={clsx(styles.label, className)}>
      <div>{label}</div>
    </div>
  );
};
export default FormLabel;
